

























































































import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";

import logoSvg from "@/assets/svg/logo.svg";

export default createComponent({
  setup(props: {}, context: any) {
    // context.refsでエラーになるのでcontextはany

    if (!context.root.$route.params.token) {
      context.root.$router.push({ name: "404" });
    }

    let displayFlag = ref(false);

    const globalStore = context.root.$store;

    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const response = computed(() => memberStore.response);

    const loading = computed(() => memberStore.loading);

    const isShowPassword = ref<boolean>(false);
    const passwordUpdateParams = computed(
      () => memberStore.passwordUpdateParams
    );
    const passwordStrengthProgress = computed(
      () => memberStore.passwordStrengthProgress
    );

    // 確認実行前からエラーメッセージが出るのを防ぐ用
    const validateUpdateActionFlag = ref<boolean>(false);

    const displayPasswordUpdateErrorFlag = computed(
      () => memberStore.displayPasswordUpdateErrorFlag
    );
    const displayPasswordUpdateError = computed(
      () => memberStore.displayPasswordUpdateError
    );

    const inputUpdatePassword = (e: string) => {
      memberStore.inputUpdatePassword(e);
      memberStore.setPasswordStrengthProgress();
      memberStore.validatePasswordUpdateParams();
    };

    const validateUpdateAction = () => {
      validateUpdateActionFlag.value = true;
      memberStore.validatePasswordUpdateParams();
      if (!displayPasswordUpdateErrorFlag.value) {
        updatePassword();
      }
    };

    const updatePassword = async () => {
      await memberStore.updatePasswordWithToken(
        context.root.$route.params.token
      );
      const apiResponse = response.value;
      const apiResponseData = apiResponse.data;

      // メッセージがあれば取得
      let apiMessage = "";
      if (apiResponseData.messages
        && apiResponseData.messages.length > 0
        && apiResponseData.messages[0] != ""
      ) {
        apiMessage = apiResponseData.messages[0];
      }

      if (apiResponse.status >= 400) {
        let message = "パスワードの変更に失敗しました。";
        if(apiMessage != "") {
          message = apiMessage;
        }
        displayuiStore.showErrorSnackBar(message);
      }
      else {
        let message = "パスワードの変更に成功しました。";
        if(apiMessage != "") {
          message = apiMessage;
        }
        displayuiStore.showSuccessSnackBar(message);

        memberStore.clearPasswordUpdateParams();
        memberStore.clearPasswordUpdateDisplayError();
        memberStore.clearPasswordStrengthProgress();
        context.root.$router.push({ name: "Login" });
      }

      memberStore.clearResponse();
    };

    onMounted(async () => {
      memberStore.clearResponse();
      memberStore.clearPasswordUpdateParams();
      memberStore.clearPasswordUpdateDisplayError();
      memberStore.clearPasswordStrengthProgress();

      // パスワードリセットトークン検証
      await memberStore.verifyResetPasswordToken(
        context.root.$route.params.token
      );
      if (response.value.status >= 400) {
        await context.root.$router.replace({ name: "404" });
        location.reload(); // 白画面回避
      } else {
        displayFlag.value = true;
      }
    });

    return {
      loading,
      passwordUpdateParams,
      validateUpdateActionFlag,
      displayPasswordUpdateErrorFlag,
      displayPasswordUpdateError,
      inputUpdatePassword,
      validateUpdateAction,
      isShowPassword,
      passwordStrengthProgress,
      displayFlag
    };
  },
  components: {
    logoSvg
  }
});
